class DynamicCollectionNavigator {
  constructor() {
    this.productContainer = null;
    this.isLoading = false;
    this.currentUrl = window.location.href;
    
    this.init();
  }

  init() {
    // Aguarda o DOM estar pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.productContainer = document.querySelector('.collection__results');
    this.setupNavigationListeners();
    this.setupPopstateListener();
    this.setupLoadingOverlay();
  }

  setupNavigationListeners() {
    const navigationItems = document.querySelectorAll('.collection-navigator__item');
    
    navigationItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (this.isLoading) return;
        
        const targetUrl = item.getAttribute('href');
        const isCurrentPage = item.hasAttribute('aria-current');
        
        if (!isCurrentPage && targetUrl) {
          this.navigateToCollection(targetUrl, item);
        }
      });
    });
  }

  setupPopstateListener() {
    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.collectionUrl) {
        this.loadCollection(e.state.collectionUrl, false);
      }
    });
  }

  setupLoadingOverlay() {
    // Criar overlay de loading
    const overlay = document.createElement('div');
    overlay.className = 'collection-loading-overlay';
    overlay.innerHTML = `
      <div class="collection-loading-spinner">
        <div class="spinner"></div>
        <p>Carregando produtos...</p>
      </div>
    `;
    document.body.appendChild(overlay);

    // Adicionar estilos CSS
    const style = document.createElement('style');
    style.textContent = `
      .collection-loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
      }

      .collection-loading-overlay.active {
        opacity: 1;
        visibility: visible;
      }

      .collection-loading-spinner {
        text-align: center;
        padding: 2rem;
        background: white;
        border-radius: 12px;
        box-shadow: 0 10px 40px rgba(0,0,0,0.1);
      }

      .spinner {
        width: 40px;
        height: 40px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid #ff4444;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 1rem;
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      .collection-loading-spinner p {
        margin: 0;
        font-weight: 500;
        color: #666;
      }

      .collection-fade-out {
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.4s ease;
      }

      .collection-fade-in {
        opacity: 1;
        transform: translateY(0);
        transition: all 0.4s ease;
      }

      .collection-navigator__item {
        transition: all 0.3s ease;
      }

      .collection-navigator__item.loading {
        pointer-events: none;
        opacity: 0.6;
      }
    `;
    document.head.appendChild(style);
  }

  async navigateToCollection(url, clickedItem) {
    this.showLoading();
    this.updateActiveNavItem(clickedItem);
    
    try {
      await this.loadCollection(url, true);
      
      // Atualizar URL sem recarregar
      const state = { collectionUrl: url };
      history.pushState(state, '', url);
      this.currentUrl = url;
      
    } catch (error) {
      console.error('Erro ao carregar coleção:', error);
      this.showError();
    } finally {
      this.hideLoading();
    }
  }

  async loadCollection(url, updateHistory = true) {
    try {
      // Adicionar parâmetro para indicar requisição AJAX
      const fetchUrl = url + (url.includes('?') ? '&' : '?') + 'view=ajax';
      
      const response = await fetch(fetchUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      this.updateProductsContent(html);
      this.updatePageTitle(html);
      
      // Scroll suave para o topo da lista de produtos
      this.scrollToProducts();
      
    } catch (error) {
      throw error;
    }
  }

  updateProductsContent(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Encontrar o novo conteúdo de produtos
    const newProductsContent = tempDiv.querySelector('.collection__results');
    const newTopBar = tempDiv.querySelector('.collection-top-bar, .facets__summary');
    
    if (newProductsContent && this.productContainer) {
      // Animação de saída
      this.productContainer.classList.add('collection-fade-out');
      
      setTimeout(() => {
        // Substituir conteúdo
        this.productContainer.innerHTML = newProductsContent.innerHTML;
        
        // Atualizar barra superior se existir
        if (newTopBar) {
          const currentTopBar = document.querySelector('.collection-top-bar, .facets__summary');
          if (currentTopBar) {
            currentTopBar.innerHTML = newTopBar.innerHTML;
          }
        }
        
        // Animação de entrada
        this.productContainer.classList.remove('collection-fade-out');
        this.productContainer.classList.add('collection-fade-in');
        
        // Reinicializar componentes Shopify se necessário
        this.reinitializeComponents();
        
        setTimeout(() => {
          this.productContainer.classList.remove('collection-fade-in');
        }, 400);
        
      }, 200);
    }
  }

  updatePageTitle(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    const titleMatch = html.match(/<title[^>]*>(.*?)<\/title>/i);
    if (titleMatch && titleMatch[1]) {
      document.title = titleMatch[1].trim();
    }
  }

  updateActiveNavItem(clickedItem) {
    // Remover estado ativo de todos os itens
    const allNavItems = document.querySelectorAll('.collection-navigator__item');
    allNavItems.forEach(item => {
      item.classList.remove('collection-navigator__item--active');
      item.querySelector('.collection-navigator__circle')?.classList.remove('collection-navigator__circle--active');
      item.removeAttribute('aria-current');
    });

    // Adicionar estado ativo ao item clicado
    if (clickedItem) {
      clickedItem.classList.add('collection-navigator__item--active');
      clickedItem.querySelector('.collection-navigator__circle')?.classList.add('collection-navigator__circle--active');
      clickedItem.setAttribute('aria-current', 'page');
    }
  }

  reinitializeComponents() {
    // Reinicializar componentes Shopify que podem ter sido perdidos
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
    
    // Reinicializar reveal-items se existir
    const revealElements = document.querySelectorAll('reveal-items');
    revealElements.forEach(element => {
      if (element.connectedCallback) {
        element.connectedCallback();
      }
    });

    // Disparar evento customizado para outros scripts
    document.dispatchEvent(new CustomEvent('collection:updated', {
      detail: { container: this.productContainer }
    }));
  }

  scrollToProducts() {
    const productsSection = document.querySelector('.collection__results');
    if (productsSection) {
      const offset = 100; // Offset para não colar no topo
      const elementPosition = productsSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  showLoading() {
    this.isLoading = true;
    const overlay = document.querySelector('.collection-loading-overlay');
    if (overlay) {
      overlay.classList.add('active');
    }

    // Adicionar classe loading aos itens de navegação
    const navItems = document.querySelectorAll('.collection-navigator__item');
    navItems.forEach(item => item.classList.add('loading'));
  }

  hideLoading() {
    this.isLoading = false;
    const overlay = document.querySelector('.collection-loading-overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }

    // Remover classe loading
    const navItems = document.querySelectorAll('.collection-navigator__item');
    navItems.forEach(item => item.classList.remove('loading'));
  }

  showError() {
    const overlay = document.querySelector('.collection-loading-overlay');
    if (overlay) {
      overlay.querySelector('.collection-loading-spinner').innerHTML = `
        <div style="color: #ff4444; font-size: 2rem; margin-bottom: 1rem;">⚠️</div>
        <p style="color: #ff4444;">Erro ao carregar produtos</p>
        <button onclick="window.location.reload()" style="margin-top: 1rem; padding: 0.5rem 1rem; background: #ff4444; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Recarregar página
        </button>
      `;
    }
  }
}

// Inicializar quando a página carregar
new DynamicCollectionNavigator();